// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  recaptchaKey: '6LfSJM8ZAAAAAAdv5PW74IDcG5yYmHW6P1t91gNw',
  apiBaseUrl: 'https://maxis360web.azurewebsites.net/api/',
  imageUrl: 'https://maxis360web.azurewebsites.net/',
  authCodeFlowConfig: {
    issuer: 'https://did-staging.maxis.com.my/oidc/',
    redirectUri: 'https://localhost:4200/redirect',
    clientId: '4bca778f-69ad-4545-bb84-325edf45eea3',
    responseType: 'code',
    // secret: '',
    scope: 'openid email name uuid brand msisdn entitlements offline_access',
    showDebugInformation: true,
    sessionChecksEnabled: true
  },
  maxisSSO: 'https://did-staging.maxis.com.my/oidc/authorize',
  maxisSignOut: 'https://did-staging.maxis.com.my/logout?returnurl=https://localhost:4200/redirect',
  gameFillerImage: 'https://api.dkcorp.com/assets/Images/wx45r3sj-w1200.png'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
